import { SelectOption } from "../../../types/select";
import { isObject } from "./isObject";

export function isSelectOption(val: unknown): val is SelectOption {
  return isObject(val) && typeof val.label === "string" && "value" in val;
}
